import React from 'react';
import useLocalStorage from '../hooks/useLocalStorage';
import B2BRfqForm from '../components/sections/B2BRfqForm';

const Quote = () => {
  const [quoteCart, setQuoteCart] = useLocalStorage('sees_quote_cart', []);

  const handleUpdateQuantity = (cartId, quantity) => {
    setQuoteCart(quoteCart.map(item => 
      item.cartId === cartId ? { ...item, quantity: parseInt(quantity) || 1 } : item
    ));
  };

  const handleRemoveFromQuote = (cartId) => {
    setQuoteCart(quoteCart.filter(item => item.cartId !== cartId));
  };

  const handleSubmitRfq = (payload) => {
    console.log('Quote Request sent to HubSpot:', payload);
    // After success, clear the cart to prevent resubmission
    setQuoteCart([]);
  };

  return (
    <>
      <B2BRfqForm 
        quoteCart={quoteCart}
        onRemoveFromQuote={handleRemoveFromQuote}
        onUpdateQuantity={handleUpdateQuantity}
        onSubmitRfq={handleSubmitRfq}
        topOuterDivider
        bottomOuterDivider
      />
    </>
  );
};

export default Quote;
